export default "__VITE_ASSET__EfsoPcLR__"